import useAnimation from "@/mono/lib/hooks/useAnimation";
import { forwardRef, useImperativeHandle } from "react";
import styled, { useTheme } from "styled-components";

const Logo = forwardRef((props, ref) => {
  const theme = useTheme();

  const { animateIn, animateOut } = useAnimation({
    inParams: {
      onUpdate: (v) => {
        //
      },
    },
    outParams: {
      onUpdate: (v) => {
        //
      },
    },
  });

  useImperativeHandle(ref, () => ({
    animateIn,
    animateOut,
  }));

  return (
    <StyledLogo className="logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 584.9 186.7"
      >
        <path
          d="M94.7 0C76.4 0 55.3 6.6 40.1 21.8V3.5H0v179.8h40.1V77.5c0-30.8 22.1-42.9 41.1-42.9s37.3 12.1 37.3 39.4v109.3h40.1V65.7c0-20-5.1-35.1-14.1-45.9C133.3 6.4 115.9 0 94.7 0ZM365.1 3c-7-2-14.8-3-23.2-3-18.3 0-39.4 6.6-54.6 21.8V3.5h-40.1v179.8h40.1V77.5c0-30.8 22.1-42.9 41.1-42.9s33.4 9.2 36.6 29.8c.5 3 .7 6.2.7 9.6v109.3h40.1V65.7C405.8 30.6 390 10.3 365 3ZM502.8 0c-49.4 0-83.7 34.9-83.7 93.4s36 93.4 86.1 93.4 69.8-20.1 78.1-55.3h-39.8c-4.5 14.2-20.4 22.5-38.4 22.5-25.9 0-43.9-17.6-46.3-52.9h125.9C588.2 32.5 547.7 0 502.8 0Zm-41.9 70.5c5.9-25.2 22.1-38 41.8-38s36.7 13.1 41.1 38h-83ZM182.2 3.5h40.1v179.8h-40.1z"
          fill={theme.theme.floatingTitle}
        />
      </svg>
    </StyledLogo>
  );
});

export const BoxedLogo = forwardRef((props, ref) => {
  const theme = useTheme();

  const { animateIn, animateOut } = useAnimation({
    inParams: {
      onUpdate: (v) => {
        //
      },
    },
    outParams: {
      onUpdate: (v) => {
        //
      },
    },
  });

  useImperativeHandle(ref, () => ({
    animateIn,
    animateOut,
  }));

  return (
    <StyledLogo className="boxed-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        version="1.1"
        viewBox="0 0 1920 916.7"
      >
        <defs>
          <style>
            {`
            .st0 {
              fill: ${theme.theme.textColor};
            }
          `}
          </style>
        </defs>
        <g id="Group_568">
          <path
            id="Path_3947"
            d="m859.1 295.8-20 14.3-15.1-24.3-15 24.4-20.1-14.3 18.6-22-28.3-6.8 7.9-23.9 26.3 10.9-2-28.5h24.7l-1.9 28.5 26.4-11 8 23.8-28.2 6.9 18.7 21.9ZM751.3 637l-12.2-81.1h-56.9L669.4 637h-56.1L674 279.8h74.1L808 637h-56.6ZM589.1 400.4h-55.7v-41.2c.1-8.2-3.2-16.2-9.1-21.9a29.666 29.666 0 0 0-40.9 0c-5.8 5.8-9.1 13.7-9 21.9v198.6c-.1 8.2 3.1 16 9 21.7 11.6 10.7 29.4 10.7 40.9 0 5.9-5.7 9.2-13.5 9.1-21.7v-50.9h55.7v48.9c-.1 47.1-38.4 85.1-85.5 85-22.5 0-44-9-59.9-24.9-16.2-15.7-25.2-37.5-24.9-60.1V361.3c0-47 38.1-85.2 85.1-85.3 22.7 0 44.4 9 60.4 25 16.2 15.8 25.1 37.6 24.7 60.2v39.1ZM373.7 691.1h-53.4V225.6h53.4v465.5Zm-98.6-135.4c.5 22.6-8.3 44.3-24.3 60.3-15.9 16.4-38 25.3-60.8 24.7-23.2.7-45.6-8.5-61.5-25.3a82.536 82.536 0 0 1-23.6-59.7V548h55.9v9.8c-.1 8.2 3.1 16 8.9 21.7 5.3 5.6 12.8 8.5 20.5 8 7.6.5 15.1-2.5 20.3-8 5.9-5.7 9.2-13.5 9.1-21.7v-72.3c-11.7 10.6-26.9 16.6-42.7 16.8-5.4 0-10.8-.4-16.1-1.3-15.7-2.3-29.9-10.7-39.5-23.4a97.526 97.526 0 0 1-16.4-60.3v-61.1c.7-15.9 5.9-31.4 15.1-44.5 9.1-13.2 22-23.5 36.9-29.4 10.5-4.2 21.8-6.4 33.1-6.2 23.2-.6 45.6 8.7 61.5 25.6 15.6 15.9 24.1 37.4 23.6 59.7v194.4ZM0 916.7h916.7V0H0v916.7Z"
            className="st0"
          />
          <path
            id="Path_3948"
            d="M190.1 329.1c-7.7-.5-15.2 2.5-20.5 8.1-5.8 5.8-9 13.7-8.9 21.9V422c-.3 9.9 4 19.4 11.6 25.8 5 3.8 11.2 5.9 17.5 5.7 13.5 1 25.6-8.3 28.2-21.6.8-3.3 1.3-6.6 1.5-10V359c.1-8.2-3.2-16.1-9.1-21.9-5.2-5.6-12.7-8.6-20.4-8.1"
            className="st0"
          />
          <path
            id="Path_3949"
            d="M690.4 506.8h40.7l-20.4-145.3-20.4 145.3Z"
            className="st0"
          />
          <path
            id="Path_3950"
            d="M1047.5 249.7c-17-.6-31.3 12.7-31.9 29.7v85.2h-31v-139h31v14.2c11.3-10.9 26.5-16.9 42.2-16.8 29.4 0 49.4 16 49.4 50.8v90.9h-31v-84.5c0-21.1-11.8-30.5-28.9-30.5"
            className="st0"
          />
          <path
            id="Rectangle_956"
            d="M1138.9 225.6h31v139h-31z"
            className="st0"
          />
          <path
            id="Path_3951"
            d="M1265.3 249.7c-17-.6-31.3 12.7-31.9 29.7v85.2h-31v-139h31v14.2c11.4-10.9 26.5-16.9 42.2-16.8 29.4 0 49.4 16 49.4 50.8v90.9h-31v-84.5c0-21.1-11.8-30.5-28.9-30.5"
            className="st0"
          />
          <path
            id="Path_3952"
            d="M1348.7 295.1c0-45.2 26.5-72.2 64.7-72.2s66 25.1 63.3 78h-97.3c1.9 27.3 15.8 40.9 35.8 40.9 12.6 1.2 24.6-5.8 29.7-17.4h30.7c-6.4 27.3-31 42.8-60.4 42.8s-66.6-27.3-66.6-72.2m96.5-17.5c-1.2-16.7-15.1-29.6-31.8-29.4-15.3 0-27.8 9.9-32.3 29.4h64.1Z"
            className="st0"
          />
          <path
            id="Path_3953"
            d="M976.7 457.5c0-45.2 28.1-72.2 66.3-72.2 29.5-1.8 55.6 19.1 60.1 48.4h-31.6c-3-13.2-15.1-22.3-28.6-21.6-21.9 0-34.7 17.1-34.7 45.4s12.8 45.4 34.7 45.4c15.1.6 28.1-10.6 29.7-25.7h31.6c-3 31.1-30.1 54.2-61.2 52.4-38.2 0-66.3-27.3-66.3-72.2"
            className="st0"
          />
          <path
            id="Path_3954"
            d="M1126.6 388h31v21.1a51.34 51.34 0 0 1 42.5-23.8h5.3v31.3h-5.3c-20.8 0-42.5 10.4-42.5 35.8V527h-31V388Z"
            className="st0"
          />
          <path
            id="Path_3955"
            d="M1213.5 457.5c0-45.2 26.5-72.2 64.7-72.2s66 25.1 63.3 78h-97.3c1.9 27.3 15.8 40.9 35.8 40.9 12.6 1.2 24.6-5.8 29.7-17.4h30.7c-6.4 27.3-31 42.8-60.4 42.8s-66.6-27.3-66.6-72.2m96.5-17.5c-1.2-16.7-15.1-29.6-31.8-29.4-15.3 0-27.8 9.9-32.3 29.4h64.1Z"
            className="st0"
          />
          <path
            id="Path_3956"
            d="M1447.3 511.7c-11.4 11.7-27 18.1-43.3 17.9-24.9 0-46-15-46-42.5s24.3-41.4 59.1-44.9c21.7-2.9 31.3-5.6 31.3-15.8s-9.3-15.8-26.2-15.8-27 7.5-28.3 19.5h-30.7c2.4-29.9 29.4-44.9 59.3-44.9s55.9 13.1 55.9 46.2v95.5h-31v-15.3Zm-35.3-6.9c16.6 0 35.3-9.3 35.3-30.2v-15.5c-9.1 3-18.5 4.9-28.1 5.9-17.9 2.1-29.9 7.5-29.9 20.6s9.9 19.2 22.7 19.2"
            className="st0"
          />
          <path
            id="Path_3957"
            d="M1515.2 485.9V414h-21.7v-25.9h21.7V355h31v33.1h27V414h-27v71.9c0 10.4 5.9 15.3 16.6 15.3h10.4v25.9h-13.9c-27 0-44.1-13.4-44.1-41.2"
            className="st0"
          />
          <path
            id="Rectangle_957"
            d="M1598.8 388h31v139h-31z"
            className="st0"
          />
          <path
            id="Path_3958"
            d="M1649.1 388h33.1l36.1 104 37.2-104h31l-51.9 139h-33.7L1649 388Z"
            className="st0"
          />
          <path
            id="Path_3959"
            d="M1791.8 457.5c0-45.2 26.5-72.2 64.7-72.2s66 25.1 63.3 78h-97.3c1.9 27.3 15.8 40.9 35.8 40.9 12.6 1.2 24.5-5.8 29.7-17.4h30.7c-6.4 27.3-31 42.8-60.4 42.8s-66.6-27.3-66.6-72.2m96.6-17.5c-1.2-16.7-15.1-29.6-31.8-29.4-15.3 0-27.8 9.9-32.3 29.4h64.1Z"
            className="st0"
          />
          <path
            id="Path_3960"
            d="M1065.9 674.2c-11.4 11.7-27 18.1-43.3 17.9-24.9 0-46-15-46-42.5s24.3-41.4 59.1-44.9c21.7-2.9 31.3-5.6 31.3-15.8s-9.3-15.8-26.2-15.8-27 7.5-28.3 19.5h-30.7c2.4-29.9 29.4-44.9 59.3-44.9s55.9 13.1 55.9 46.2v95.4h-31v-15.2Zm-35.3-7c16.6 0 35.3-9.4 35.3-30.2v-15.5c-9.1 3-18.5 4.9-28.1 5.9-17.9 2.1-29.9 7.5-29.9 20.6s9.9 19.2 22.7 19.2"
            className="st0"
          />
          <path
            id="Path_3961"
            d="M1127.4 700.9h31c1.6 9.4 12.6 19.2 31.3 19.2 16.6 1.6 31.4-10.6 33-27.2.1-1.4.2-2.7.1-4.1V673c-10.3 12.3-25.7 19.1-41.7 18.4-35.3 0-60.4-26.5-60.4-71.9s25.1-71.9 60.4-71.9c16-.7 31.4 6.2 41.7 18.4v-15.8h31v138.4c0 36.6-29.7 56.7-64.2 56.7s-59.6-18.7-62.3-44.6m95.5-81c0-28.3-13.4-45.2-35-45.2s-35 17.4-35 45.2 13.1 45.2 35 45.2 35-17.1 35-45.2"
            className="st0"
          />
          <path
            id="Path_3962"
            d="M1278.4 619.9c0-45.2 26.5-72.2 64.7-72.2s66 25.1 63.3 78h-97.3c1.9 27.3 15.8 40.9 35.8 40.9 12.6 1.2 24.6-5.8 29.7-17.4h30.7c-6.4 27.3-31 42.8-60.4 42.8s-66.6-27.3-66.6-72.2m96.6-17.5c-1.2-16.7-15.1-29.6-31.8-29.4-15.3 0-27.8 9.9-32.3 29.4h64.1Z"
            className="st0"
          />
          <path
            id="Path_3963"
            d="M1493.8 574.5c-17-.6-31.3 12.7-31.9 29.7v85.2h-31v-139h31v14.2c11.4-10.9 26.5-16.9 42.2-16.8 29.4 0 49.4 16 49.4 50.8v90.9h-31V605c0-21.1-11.8-30.5-28.9-30.5"
            className="st0"
          />
          <path
            id="Path_3964"
            d="M1577.2 619.9c0-45.2 28.1-72.2 66.3-72.2 29.5-1.8 55.6 19.1 60.1 48.4H1672c-3-13.2-15.1-22.3-28.6-21.7-21.9 0-34.7 17.1-34.7 45.4s12.8 45.4 34.7 45.4c15.1.6 28.1-10.6 29.7-25.7h31.6c-3 31.1-30.1 54.2-61.2 52.4-38.2 0-66.3-27.3-66.3-72.2"
            className="st0"
          />
          <path
            id="Path_3965"
            d="M1731.4 717.5h15.5c7.5 0 11.8-1.6 16.6-15.3l4.6-12.8-55.6-139h32.9l37.7 103.2 35.8-103.2h30.7l-57.5 157.7c-8 22.2-17.6 34.8-40.1 34.8h-20.6v-25.3Z"
            className="st0"
          />
        </g>
      </svg>
    </StyledLogo>
  );
});

export const AcronymLogo = forwardRef((props, ref) => {
  const theme = useTheme();

  const { animateIn, animateOut } = useAnimation({
    inParams: {
      onUpdate: (v) => {
        //
      },
    },
  });

  useImperativeHandle(ref, () => ({
    animateIn,
    animateOut,
  }));

  return (
    <StyledLogo className="acronym-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        version="1.1"
        viewBox="0 0 1772.1 1080"
      >
        <path
          d="m1587 163.2 46.6 33 34.9-56.7 35.1 56.5 46.4-33.1-43.4-50.9 65.5-16-18.5-55.4-61.1 25.6 4.3-66.2-57.2.1 4.5 66.2L1583 41l-18.4 55.4 65.6 15.8-43.2 51zM926.5 963c54.1 0 100.5-19.1 139.1-57.4 38.7-38.3 58-84.9 58-139.8V652.4H994.3v118.2c0 19.8-7 36.6-21.1 50.4-14.1 13.8-27.6 18.6-47.3 18.6s-33.8-4.7-47.7-18.6c-13.8-13.8-20.8-30.7-20.8-50.4V309.9c0-19.8 6.9-36.7 20.8-50.8 13.8-14.1 27.9-18.9 47.7-18.9s33.2 4.8 47.3 18.9c14.1 14.1 21.1 31 21.1 50.8v95.6h129.3v-90.8c0-54.5-19.1-101.1-57.4-139.8-38.2-38.7-84.8-58.1-139.8-58.1s-101.1 19.3-139.8 57.7c-38.7 38.5-58 85.2-58 140.1v451c0 54.5 19.2 101 57.7 139.5 38.5 38.4 85.2 57.7 140.1 57.7ZM1339.4 766.1h131.9l28.5 188.3h131.4l-138.9-828.8h-172l-140.9 828.8h130.2l29.8-188.3Zm66.3-450.7 47.2 337h-94.4l47.2-337ZM197.5 963c56.4 0 103.4-19.1 141-57.4 37.7-38.3 56.5-84.9 56.5-139.8V314.7c0-54.5-18.3-100.6-54.7-138.5-37.9-39.6-85.5-59.4-142.8-59.4s-53.3 4.9-76.9 14.5C84.5 146.2 56 169 35 199.5 14 230.3 1.8 264.7 0 303v141.8c0 59.8 12.7 106.4 38.1 139.8 22.1 29.4 52.6 47.5 91.6 54.3 11.7 2 24.1 3.1 37.3 3.1 35.6 0 68.6-13 99.1-38.9v167.7c0 19.8-7 36.6-21 50.4-14 13.8-27.4 18.6-47.1 18.6s-33.7-4.7-47.5-18.6c-13.8-13.8-20.7-30.7-20.7-50.4v-22.7H0v17.8c0 54.5 18.3 100.7 54.7 138.5 37.4 39.1 85 58.7 142.8 58.7Zm65.1-483.9c-8.3 33.4-32.1 50.1-65.4 50.1s-32.2-5.9-40.5-13.3c-18.5-15.8-27-35.7-27-59.8v-146c0-19.8 6.9-36.7 20.7-50.8 13.8-14.1 27.8-18.9 47.5-18.9s33.1 4.8 47.1 18.9c14 14.1 21 31 21 50.8v146c0 5.3-1.1 13-3.5 23.1ZM499.8 0h124v1080h-124z"
          fill={theme.theme.floatingTitle}
        />
      </svg>
    </StyledLogo>
  );
});

export default Logo;

const StyledLogo = styled.div`
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }
`;
